/**
 * A smooth scroll implementation
 *
 * Mostly forked from https://github.com/iamdustan/smoothscroll/blob/master/src/smoothscroll.js
 */

import scheduleAnimationCallback from '../scheduleAnimationCallback';

// Implement a smooth scrolling handler
// To do this we use a requestAnimationFrame loop
// and ease the amount we scroll by within this loop until
// we hit the desired position

// Our easing function, it provdes a smooth easing curve
function ease(value) {
  return 0.5 * (1 - Math.cos(Math.PI * value));
}

function scrollElement(x, y) {
  this.scrollLeft = x;
  this.scrollTop = y;
}

const getCurrentTime =
  // ensure window is defined before checking for window.performance
  typeof window !== 'undefined' &&
  window.performance &&
  typeof window.performance.now === 'function'
    ? window.performance.now.bind(window.performance)
    : Date.now;

// The method we call on each requestAnimationFrame loop
function step(context) {
  const time = getCurrentTime();
  let currentX, currentY;
  let elapsedTime = (time - context.startTime) / context.duration;
  // avoid elapsed times larger than 1
  // Note, for some reason Math.max doesn't work correctly here
  // It may round the values or do some other checking that the
  // comparison below doees not
  elapsedTime = elapsedTime > 1 ? 1 : elapsedTime;
  // apply the easing to the value
  const value = ease(elapsedTime);

  if (typeof context.x === 'number') {
    currentX = context.startX + (context.x - context.startX) * value;
  }
  if (typeof context.y === 'number') {
    currentY = context.startY + (context.y - context.startY) * value;
  }

  context.scrollingMethod.call(context.element, currentX, currentY);

  if (
    (currentX === context.x &&
      typeof currentX !== 'undefined' &&
      typeof context.x !== 'undefined') ||
    (currentY === context.y &&
      typeof currentY !== 'undefined' &&
      typeof context.y !== 'undefined')
  ) {
    // We have hit our bounds so we exit here and prevent the recursion
    return;
  }
  // If we still haven't hit our scrolling bounds
  // call step method with our current context and recurse
  scheduleAnimationCallback(step.bind(window, context));
}

export default function smoothScroll({element, x, y, duration}) {
  let scrollable, startX, startY, scrollMethod;
  const startTime = getCurrentTime();

  // If we are scrolling the body then we delegate to methods and values
  // from the window directly, otherwise we fallback to getting that information
  // from the element (this is mostly because older IE doesn't support the same
  // scrollLeft/Top values)
  if (element === document.body) {
    scrollable = window;
    startX = window.scrollX || window.pageXOffset;
    startY = window.scrollY || window.pageYOffset;
    scrollMethod = window.scroll || window.scrollTop;
  } else {
    scrollable = element;
    startX = element.scrollLeft;
    startY = element.scrollTop;
    scrollMethod = scrollElement;
  }

  step({
    startTime,
    startX,
    startY,
    x,
    y,
    duration,
    scrollingMethod: scrollMethod,
    element: scrollable,
  });
}
